<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import ItineraryEditGeneralInfo from '../../components/itinerary/ItineraryEditGeneralInfo';
import ItineraryEditInfo from '../../components/itinerary/ItineraryEditInfo';
import ItineraryAddCountryModal from '../../components/itinerary/ItineraryAddCountryModal';
import ItineraryAddTripThemeModal from '../../components/itinerary/ItineraryAddTripThemeModal';
import ItineraryMatrixAgesModal from '../../components/itinerary/ItineraryMatrixAgesModal';

export default {
  name: 'ItineraryEditGeneral',
  components: {
    ItineraryMatrixAgesModal,
    ItineraryEditGeneralInfo,
    ItineraryEditInfo,
    ItineraryAddCountryModal,
    ItineraryAddTripThemeModal,
  },
  data() {
    return {
      showCountriesModal: false,
      showTripThemesModal: false,
      showMatrixAgesModal: false,
      saveSuccess: true,
      matrixAges: [],
    };
  },
  computed: {
    ...mapState({
      loading: state => state.itinerary.edit.loading,
      error: state => state.itinerary.edit.error,
      itinerary: state => state.itinerary.edit.item,
      masterCountriesLoading: state => state.itinerary.masterCountries.loading,
      productTypes: state => state.itinerary.productTypes.items,
      salesCountriesItems: state => state.itinerary.salesCountries.items,
      salesCountriesLoading: state => state.itinerary.salesCountries.loading,
      tripThemesLoading: state => state.itinerary.tripThemes.loading,
      assignedTripThemesItems: state => state.itinerary.assignedTripThemes.items,
      assignedTripThemesLoading: state => state.itinerary.assignedTripThemes.loading,
      selectedDomain: state => state.itinerary.domains.selected,
    }),
    ...mapGetters({
      getAvailableItinerarySalesCountries: 'itinerary/getAvailableItinerarySalesCountries',
      getAvailableItineraryTripThemes: 'itinerary/getAvailableItineraryTripThemes',
      mapItineraryTripCountries: 'itinerary/mapItineraryTripCountries',
    }),
  },
  created() {
    const itineraryId = this.$route.params.id;
    if (!this.productTypes.length) {
      this.getProductTypes();
    }
    this.getCountriesByProductTypeId(this.itinerary.productTypeId);
    this.getItinerarySalesCountries(itineraryId);
    this.getElcanoTripThemes();
    this.getAssignedTripThemes(itineraryId);
  },
  methods: {
    ...mapActions({
      getProductTypes: 'itinerary/getProductTypes',
      updateItinerary: 'itinerary/updateItinerary',
      getCountriesByProductTypeId: 'itinerary/getCountriesByProductTypeId',
      getItinerarySalesCountries: 'itinerary/getItinerarySalesCountries',
      updateItinerarySalesCountries: 'itinerary/updateItinerarySalesCountries',
      getElcanoTripThemes: 'itinerary/getElcanoTripThemes',
      getAssignedTripThemes: 'itinerary/getAssignedTripThemes',
      updateAssignedTripThemes: 'itinerary/updateAssignedTripThemes',
      updateItineraryDomains: 'itinerary/updateItineraryDomains',
      cloneItinerary: 'itinerary/cloneItinerary',
    }),
    updateItinerarySalesCountry(event) {
      this.updateItinerarySalesCountries(event).then(() => {
        this.showCountriesModal = false;
      });
    },
    updateItineraryTripTheme(event) {
      this.updateAssignedTripThemes(event).then(() => {
        this.showTripThemesModal = false;
      });
    },
    updateItineraryDomain(event) {
      this.updateItineraryDomains({
        itineraryId: this.$route.params.id,
        itineraryDomains: [event],
      });
    },
    cloneThisItinerary() {
      this.cloneItinerary({
        itineraryId: this.$route.params.id,
      });
    },
  },
};
</script>

<template>
  <div>
    <v-layout v-if="itinerary" row wrap>
      <v-flex xl7>
        <itinerary-edit-general-info
          :loading="loading"
          :error="error"
          :item="itinerary"
          :product-types="productTypes"
          :selected-domain="selectedDomain"
          @update="updateItinerary"
          @updateDomain="updateItineraryDomain"
        />
      </v-flex>
      <v-flex xl5>
        <itinerary-edit-info
          :is-extension="itinerary && itinerary.isExtension"
          :trip-themes="assignedTripThemesItems"
          :trip-themes-loading="assignedTripThemesLoading"
          :sales-countries="salesCountriesItems"
          :sales-country-loading="salesCountriesLoading"
          :trip-countries="mapItineraryTripCountries"
          @updateSalesCountries="showCountriesModal = true"
          @updateTripThemes="showTripThemesModal = true"
          @cloneItinerary="cloneThisItinerary"
          @openItineraryMatrixAges="showMatrixAgesModal = true"
        />
      </v-flex>
    </v-layout>
    <v-layout v-if="!itinerary && loading" row wrap>
      <v-flex lg12>
        <v-card>
          <v-card-title class="justify-center">
            <v-progress-circular
              indeterminate
              color="primary"
            />
            <span class="ml-2">{{ $t('itinerary.edit.general.loading') }}</span>
          </v-card-title>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout v-if="!itinerary && !loading">
      <v-flex xs12>
        <v-card>
          <v-card-title class="justify-center">
            <v-icon
              class="mr-3"
              :class="error">
              error
            </v-icon>
            <span>{{ $t('itinerary.edit.general.notFound') }}</span>
            <span class="px-1">
              <router-link :to="{ name: 'ItineraryOverview' }">
                {{ $t('itinerary.edit.general.back') }}
              </router-link>
            </span>
          </v-card-title>
        </v-card>
      </v-flex>
    </v-layout>
    <itinerary-add-country-modal
      v-if="showCountriesModal"
      :itinerary-id="+$route.params.id"
      :available-countries="getAvailableItinerarySalesCountries"
      :selected-countries="salesCountriesItems"
      :loading="masterCountriesLoading || salesCountriesLoading"
      @update="updateItinerarySalesCountry"
      @cancel="showCountriesModal = false"
    />
    <itinerary-add-trip-theme-modal
      v-if="showTripThemesModal"
      :itinerary-id="+$route.params.id"
      :available-trip-themes="getAvailableItineraryTripThemes"
      :selected-trip-themes="assignedTripThemesItems"
      :loading="tripThemesLoading || assignedTripThemesLoading"
      @update="updateItineraryTripTheme"
      @cancel="showTripThemesModal = false"
    />
  </div>
</template>



// WEBPACK FOOTER //
// src/pages/itinerary/ItineraryEditGeneral.vue